import { clientI18n, clientIntl } from '../ClientI18n.ts';
(function(UILeaderboardUtils) {
    function tLeaderboardTabName(leaderboardTabName) {
        if (typeof leaderboardTabName == 'string') {
            const countryName = clientIntl.getCountryName(leaderboardTabName);
            if (countryName != undefined) return countryName;
            // Region names are difficult to translate and are already being taken care of by the iso package.
            // they are always shown in native language and handled by GeographicalInformationConverter
            const regionName = leaderboardTabName;
            return regionName;
        }
        return clientI18n.t(leaderboardTabName.key, leaderboardTabName.options);
    }
    UILeaderboardUtils.tLeaderboardTabName = tLeaderboardTabName;
})(UILeaderboardUtils || (UILeaderboardUtils = {}));
export var UILeaderboardUtils;
